/**
 *
 * @module logEvent
 *
 */

import LogLevel from './logLevel';

/**
 *
 * @class LogEvent
 * @implements {ToString}
 * @implements {JSONSerializable}
 * @desc Represents an event that can be logged by the Logger to its registered ILogSink instances.
 *
 */
export default class LogEvent {

    /**
     *
     * @param {Boolean} [isPublic=false] A value indicating whether or not the event is publicly visible.
     * @param {LogLevel} level The severity level of the event.
     * @param {String} [source=''] The source object that generated the event.
     * @param {String} [message=''] The message describing the event.
     * @param {Object<String, JSONSerializable>} [extraData] The dictionary containing any
     * extra data that should be logged with the event.
     *
     */
    constructor(isPublic = false, level, source = '', message = '', extraData) {

        /**
         *
         * @access private
         * @type {Boolean}
         *
         */
        this.isPublic = isPublic;

        /**
         *
         * @access private
         * @type {LogLevel}
         *
         */
        this.level = (level === undefined ? null : level);

        /**
         *
         * @access private
         * @type {String}
         *
         */
        this.source = source;

        /**
         *
         * @access private
         * @type {String}
         *
         */
        this.message = message;

        /**
         *
         * @access private
         * @type {Object<String, JSONSerializable>}
         *
         */
        this.extraData = extraData || {};

    }

    /**
     *
     * @access private
     * @returns {String}
     *
     */
    toJSON() {

        return JSON.stringify({
            isPublic: this.isPublic,
            level: LogLevel[this.level],
            source: this.source,
            message: this.message,
            extraData: this.extraData
        });

    }

    /**
     *
     * @access private
     * @returns {String}
     *
     */
    toString() {

        return `(${LogLevel[this.level]}): ${this.source} - ${this.message}`;

    }

}



// WEBPACK FOOTER //
// ./src/logging/logEvent.js